import { api } from "./api";
import { jstToday } from "./jst";

const KEY = "khf_visit";
const SID = "khf_sid";

const sessionId = () => {
  let id = localStorage.getItem(SID);
  if (!id) {
    id = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(SID, id);
  }
  return id;
};

/** Catat satu kunjungan per hari per pengunjung (tanpa pelacak pihak ketiga). */
export const trackVisit = (path) => {
  const today = jstToday();
  if (sessionStorage.getItem(KEY) === today) return;
  sessionStorage.setItem(KEY, today);
  api
    .post("/visits", {
      session_id: sessionId(),
      path: path || window.location.pathname,
      referrer: document.referrer || "",
    })
    .catch(() => {});
};
